/* ==========================================================================
   BON CHARGE — Multi-Product PDP Redesign
   Mobile-only JS companion for new-pdp-redesign.css.
   Per-product copy/images live in the registries below, keyed by Shopify
   product handle. Add a new entry to each registry to support a new PDP.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    /* --------------------------------------------------------------------------
       Per-product registries (keyed by Shopify product handle)
       -------------------------------------------------------------------------- */

    // Trust text rendered after the rating (was hardcoded in CSS ::after).
    const trustTexts = {
      'red-light-face-mask': 'Trusted by 400,000+ Customers',
      'red-light-cap': 'Trusted by 400,000+ Customers'
    };

    // Subtitle paragraph inserted directly after .pd-product-info__title (the h1).
    // FDA-cleared products get a small badge overlaid on the FIRST image of
    // the main media carousel (not on the thumb strip). Boolean per handle;
    // missing entry = no badge.
    const fdaCleared = {
      'red-light-cap': true
    };

    const titleSubtitles = {
      'red-light-face-mask': 'Support smoother-looking, radiant skin with science-backed red and near-infrared light therapy.',
      'red-light-cap': 'Powerful, lab-grade red light therapy for thicker, stronger hair.'
    };

    // Hero short-description paragraph + bullet list.
    // Optional `bulletsPopup` makes the bullet list clickable and opens a
    // shared info popup with the configured text (used to source the asterisk
    // disclaimer behind a tap).
    const descriptions = {
      'red-light-face-mask': {
        paragraph: '',
        bullets: [
          '98% reported even skin tone*',
          '96% reported glowing skin*',
          '84% saw results in just 4 weeks*'
        ],
        bulletsPopup: 'Based on customer reviews that explicitly mention at least one specific appearance-related outcome (n=50). Reviews may mention more than one outcome.'
      },
      'red-light-cap': {
        paragraph: '',
        bullets: [
          'Supports Hair Growth',
          'Thicker, Fuller-Looking Hair',
          'Stronger, Healthier-Looking Hair',
          'Revitalise Your Scalp'
        ],
        bulletsPopup: 'Based on customer reviews that explicitly mention at least one specific appearance-related outcome (n=50). Reviews may mention more than one outcome.'
      }
    };

    // Details accordion content. `heading` is optional; if null, the existing
    // theme H3 is left untouched.
    const details = {
      'red-light-face-mask': {
        heading: 'Upgrade your routine with targeted red and near-infrared light technology.',
        paragraphs: [
          'The BON CHARGE Red Light Face Mask delivers 630nm red and 850nm near-infrared light to support healthier-looking skin, helping improve the appearance of tone, texture, and reduce the appearance of fine line and wrinkles.',
          'In just 10 minutes a day, this wearable, hands-free device fits effortlessly into your routine.',
          'Lightweight, flexible, and designed for comfort, it contours to your face so you can use it while relaxing, working, or getting ready.',
          'Suitable for all skin types and built for long-term use, this rechargeable device offers a premium, cost effective alternative to frequent in clinic treatments.',
          'With consistent use, expect smoother-looking skin, a more even tone, and a naturally radiant complexion.',
          'Used and supported by dermatology clinician and BON CHARGE Scientific Advisor Dr Shabana Daya.'
        ]
      },
      'red-light-cap': {
        heading: null,
        paragraphs: [
          'The BON CHARGE Red Light Cap delivers 650nm red light therapy to support hair follicle function and overall hair health.',
          'In just 10 minutes a day, this wearable, hands-free device fits effortlessly into your routine.',
          'Lightweight, comfortable, and rechargeable — designed for consistent daily use to support thicker, stronger, healthier-looking hair.'
        ]
      }
    };

    // "Best Paired With" bundle (Figma 3068:2186).
    // - heading + subheading render above the bundle card
    // - savePercent draws the corner "Save N%" ribbon and appears in the price line
    // - title is the bundle product name (falls back to the fetched card's heading)
    // - text is the descriptive paragraph below the bundle name + rating
    const bundleProducts = {
      'red-light-face-mask': {
        handle: 'face-neck-and-chest-bundle',
        heading: 'Complete Your Results',
        subheading: 'Combine for faster, more complete results',
        title: 'Face, Neck & Chest Bundle',
        text: 'Extend your results beyond the face. Add the Neck & Chest Mask to support smoother-looking, more even skin across often-overlooked areas.',
        savePercent: 5,
        ctaText: 'ADD TO CART +'
      },
      // 'red-light-cap': {
      //   handle: 'radiance-duo-kit', //'full-face-scalp-bundle',
      //   heading: 'Complete Your Results',
      //   subheading: 'Combine face + scalp for faster, more complete results',
      //   title: 'Full Face & Scalp Bundle',
      //   text: 'Complete your results! Treat both hair and skin in the same 10-minute session. Upgrade to full face & scalp coverage for maximum impact.',
      //   savePercent: 5,
      //   ctaText: 'ADD TO CART +'
      // }
    };

    // "Why BON CHARGE …" hero block + "How It Works" cards under it.
    const howItWorks = {
      'red-light-face-mask': {
        image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/rlt_face_mask__pdp__how_it_works.jpg?v=1776050696',
        title: 'Why BON CHARGE Red Light Face Mask?',
        text: '<p>Developed with input from our Scientific Advisory Board and in-house experts, our Red Light Face Mask delivers targeted red (630nm) and near-infrared (850nm) light across the full face for consistent, even coverage.</p><p>Its flexible, lightweight design ensures a comfortable, hands-free experience making it easy to use daily and support healthier-looking, more radiant skin.</p>',
        // White-card features rendered above the cream "How It Works" cards (Figma 2572:2479).
        features: [
          {
            iconSvg: '<svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 9H1M19 11.5V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H10M14 1V5M6 1V5M12.5 18L14.5 20L19 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Consistent Daily Use',
            text: 'Just 10 minutes a day fits seamlessly into your routine, making it easy to stay consistent and see results.'
          },
          {
            iconSvg: '<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 7.00001V4.00001L18 1.00001L19 3.00001L21 4.00001L18 7.00001H15ZM15 7.00001L11 11M21 11C21 16.5229 16.5228 21 11 21C5.47715 21 1 16.5229 1 11C1 5.47716 5.47715 1.00001 11 1.00001M16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23859 8.23858 6.00001 11 6.00001" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Full Coverage',
            text: 'Even, targeted light distribution across key areas for effective, full-coverage therapy in every session.'
          },
          {
            iconSvg: '<svg viewBox="0 0 21.9999 19.8361" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9933 3.13769C8.99392 0.800272 5.65986 0.171514 3.15481 2.31188C0.64976 4.45226 0.297084 8.03085 2.26431 10.5623C3.89993 12.667 8.84989 17.106 10.4722 18.5427C10.6537 18.7034 10.7445 18.7838 10.8503 18.8154C10.9427 18.843 11.0438 18.843 11.1362 18.8154C11.2421 18.7838 11.3328 18.7034 11.5143 18.5427C13.1366 17.106 18.0866 12.667 19.7222 10.5623C21.6894 8.03085 21.3798 4.42974 18.8317 2.31188C16.2836 0.194029 12.9926 0.800272 10.9933 3.13769Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Built for Real Results',
            text: 'Engineered for comfort, convenience, and everyday use — so you can integrate it effortlessly and get lasting results.'
          }
        ],
        itemsTitle: 'How It Works',
        items: [
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10 17.6586V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V17.6586M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" stroke="#B39279" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Red Light',
            text: 'Improves Skin Appearance'
          },
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21 18C21 18 19.8096 17.5305 19 17.3021C13.8797 15.8574 10.1203 20.1426 5 18.6979C4.19041 18.4695 3 18 3 18M21 12C21 12 19.8096 11.5305 19 11.3021C13.8797 9.85739 10.1203 14.1426 5 12.6979C4.19041 12.4695 3 12 3 12M21 6C21 6 19.8096 5.53048 19 5.30206C13.8797 3.85739 10.1203 8.14261 5 6.69794C4.19041 6.46952 3 6 3 6" stroke="#B39279" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Near Infrared',
            text: 'Penetrates Deeper into the facial muscles.'
          },
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#B39279" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Daily Use',
            text: 'Visible Improvements Over Time'
          }
        ]
      },
      'red-light-cap': {
        image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/rlt_cap__pdp__how_it_works.jpg?v=1777882073',
        title: 'Why BON CHARGE Red Light Cap?',
        text: '<p>Not all red light devices are created equal with effectiveness coming down to the right wavelength, consistent use, and full coverage.</p>',
        // White-card features rendered above "How It Works" itemsTitle (Figma 2356:1268). 4 items on Cap.
        features: [
          {
            iconSvg: '<svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.00003 2C1.60003 2.5 2.20003 3 3.50003 3C6.00003 3 6.00003 1 8.50003 1C9.80002 1 10.4 1.5 11 2C11.6 2.5 12.2 3 13.5 3C16 3 16 1 18.5 1C19.8 1 20.4 1.5 21 2M1.00003 14C1.60003 14.5 2.20003 15 3.50003 15C6.00003 15 6.00003 13 8.50003 13C9.80002 13 10.4 13.5 11 14C11.6 14.5 12.2 15 13.5 15C16 15 16 13 18.5 13C19.8 13 20.4 13.5 21 14M1.00003 8C1.60003 8.5 2.20003 9 3.50003 9C6.00003 9 6.00003 7 8.50003 7C9.80002 7 10.4 7.5 11 8C11.6 8.5 12.2 9 13.5 9C16 9 16 7 18.5 7C19.8 7 20.4 7.5 21 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Optimal 650nm Wavelength',
            text: 'Delivers 650nm red light at the level used in clinical research — proven to support scalp health and visible hair growth over time.'
          },
          {
            iconSvg: '<svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 9H1M19 11.5V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H10M14 1V5M6 1V5M12.5 18L14.5 20L19 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Consistent Daily Use',
            text: 'Just 10 minutes a day fits seamlessly into your routine, making it easy to stay consistent and see results.'
          },
          {
            iconSvg: '<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 7.00001V4.00001L18 1.00001L19 3.00001L21 4.00001L18 7.00001H15ZM15 7.00001L11 11M21 11C21 16.5229 16.5228 21 11 21C5.47715 21 1 16.5229 1 11C1 5.47716 5.47715 1.00001 11 1.00001M16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23859 8.23858 6.00001 11 6.00001" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Full Scalp Coverage',
            text: 'Even, targeted light distribution across key areas of the scalp for effective, full-coverage therapy in every session.'
          },
          {
            iconSvg: '<svg viewBox="0 0 21.9999 19.8361" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9933 3.13769C8.99392 0.800272 5.65986 0.171514 3.15481 2.31188C0.64976 4.45226 0.297084 8.03085 2.26431 10.5623C3.89993 12.667 8.84989 17.106 10.4722 18.5427C10.6537 18.7034 10.7445 18.7838 10.8503 18.8154C10.9427 18.843 11.0438 18.843 11.1362 18.8154C11.2421 18.7838 11.3328 18.7034 11.5143 18.5427C13.1366 17.106 18.0866 12.667 19.7222 10.5623C21.6894 8.03085 21.3798 4.42974 18.8317 2.31188C16.2836 0.194029 12.9926 0.800272 10.9933 3.13769Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Built for Real Results',
            text: 'Engineered for comfort, convenience, and everyday use — so you can integrate it effortlessly and get lasting results.'
          }
        ],
        itemsTitle: 'How It Works',
        items: [
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10 17.6586V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V17.6586M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" stroke="#B39279" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: '650nm Red Light',
            text: 'Supports Hair Follicle Activity — Targets the scalp to support natural hair growth at the source.'
          },
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" stroke="#B39279" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Direct Scalp Delivery',
            text: 'Even Coverage — Even light distribution helps ensure consistent exposure across key areas.'
          },
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#B39279" stroke-width="2"/><path d="M12 6v6l4 2" stroke="#B39279" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            title: 'Daily Use',
            text: 'Results Over Time — Consistent 10-minute sessions support thicker, stronger, healthier-looking hair.'
          }
        ]
      }
    };

    // Scientific Advisory Board (SAB) callout. Absent products skip this section.
    const sabContent = {
      'red-light-face-mask': {
        title: 'Professional Results, Without the Ongoing Cost',
        text: '<p>Consistent use is key with LED light therapy. Instead of paying for repeated salon treatments, the BON CHARGE Red Light Face Mask lets you support your skin at home, on your schedule.</p><p>For the price of just a few clinic visits, you can use it whenever you like making it a more convenient and cost-effective option over time.</p>',
        title2: 'Backed by Skin Experts'
      }
      // 'red-light-cap': not configured — section will be skipped on Cap PDP
    };

    // "Trusted By Leading Experts" SAB banner (Figma 2572:2896 / 2357:1409).
    // Replaces the inner content of `.section-banner-sab`, preserving the
    // existing <deferred-media>/<img> so the play-on-click video still works.
    // Only renders if BOTH the element exists on the page AND a config entry exists.
    const sabBanner = {
      'red-light-face-mask': {
        heading: 'Trusted by Skin Experts',
        name: 'Dr Shabana Daya',
        role: 'Physician in Integrative & Aesthetic Medicine | Diploma in Clinical Dermatology | BON CHARGE Scientific Advisor',
        quote: '"I believe in science-backed wellness technologies that support the skin\'s natural processes. Red light therapy is a powerful tool to improve overall skin appearance when used consistently."'
      },
      'red-light-cap': {
        heading: 'Trusted By Leading Experts',
        name: 'Dr Mark Hyman',
        role: 'Functional Medicine Doctor',
        quote: "“I’m so passionate about wellness tech like BON&nbsp;CHARGE that help me optimize my daily care routines and worked towards my longevity goals”"
      }
    };

    // Easy-to-Use redesign (Figma 2572:2950 / 2572:2977 / 2572:3005).
    // - title / subtitle render at the top (subtitle = bold under title)
    // - iconBlocks: exactly 3. The FIRST block uses the product's first gallery
    //   image automatically; the other two take an inline `iconSvg` string.
    //   Clicking a block activates the matching slide.
    // - steps: optional. Each entry's title/text/image overrides the value read
    //   from the original theme markup (Mask: `.steps-images-carousel__step`,
    //   Cap: `#js-easy-to-use-slide-N`). If a field isn't configured, the
    //   original is used.
    const ETU_ICONS = {
      power: '<svg viewBox="0 0 26.6667 29.3372" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M13.34 1.33333V14.6667M21.82 7.52C23.4978 9.19838 24.6403 11.3366 25.103 13.6642C25.5657 15.9919 25.3279 18.4045 24.4195 20.597C23.5111 22.7895 21.9731 24.6634 19.9998 25.9818C18.0265 27.3002 15.7065 28.0039 13.3333 28.0039C10.9601 28.0039 8.64021 27.3002 6.6669 25.9818C4.6936 24.6634 3.15553 22.7895 2.24716 20.597C1.33879 18.4045 1.10092 15.9919 1.56363 13.6642C2.02633 11.3366 3.16883 9.19838 4.84667 7.52" stroke="currentColor" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      heart: '<svg viewBox="0 0 29.1666 26.2813" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5743 4.10009C11.9085 0.98354 7.46314 0.145197 4.12307 2.99902C0.783006 5.85285 0.312771 10.6243 2.93574 13.9995C5.11657 16.8058 11.7165 22.7245 13.8796 24.6401C14.1216 24.8544 14.2426 24.9616 14.3838 25.0037C14.507 25.0405 14.6417 25.0405 14.7649 25.0037C14.9061 24.9616 15.0271 24.8544 15.2691 24.6401C17.4322 22.7245 24.0321 16.8058 26.213 13.9995C28.8359 10.6243 28.4231 5.82283 25.0256 2.99902C21.6281 0.175217 17.2402 0.98354 14.5743 4.10009Z" stroke="currentColor" stroke-width="2.50001" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
    const easyToUseConfig = {
      'red-light-face-mask': {
        title: 'Effortless Results In Just',
        subtitle: '10 Minutes A Day',
        iconBlocks: [
          {label: 'Get Started'},
          {iconSvg: ETU_ICONS.power, label: 'Get Going'},
          {iconSvg: ETU_ICONS.heart, label: 'Get Youthful Looking Skin'}
        ],
        steps: [
          {
            title: 'Get Started',
            text: 'Fasten your Red Light Face Mask over your face, securing in place using the soft cushioned Velcro straps around your head. Select your session length and setting using the controller. Choose Red Light, Near Infrared Light or both for maximum results.',
            image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_face_mask__etu_step_1.jpg?v=1778572341'
          },
          {
            title: 'Get Going',
            text: 'The portable cordless design lets you go about your activities whilst taking your session. Watch TV, read a book or simply relax whilst the red light gets to work. As little as 10 minutes, 3 times a week is all you need to see noticeable results.',
            image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_face_mask__etu_step_2.jpg?v=1778572341'
          },
          {
            title: 'Youthful Looking Skin',
            text: 'Elevate your confidence and benefit from that post-session glow, reduced fine lines/wrinkles and younger looking skin. After use, simply wipe down your Face Mask with a damp cloth.',
            image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_face_mask__etu_step_3.jpg?v=1778572340'
          }
        ]
      },
      'red-light-cap': {
        title: 'Effortless Results In Just',
        subtitle: '10 Minutes A Day',
        iconBlocks: [
          {label: 'Get Started'},
          {iconSvg: ETU_ICONS.power, label: 'Get Going'},
          {iconSvg: ETU_ICONS.heart, label: 'Get Stronger Hair'}
        ],
        steps: [
          {
            title: 'Get Started',
            text: 'Place the cap on, press start, and let the light work. Each session is pre-timed, so you can settle in with a book, emails, or your evening wind-down — a ritual that integrates seamlessly into daily life.',
            image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_cap__etu_step_1.jpg?v=1778572704'
          },
          {
            title: 'Get Going',
            text: 'The portable, cordless design lets you go about your activities whilst taking your session. As little as 10 minutes, 3 times a week is all you need to see noticeable results.',
            image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_cap__etu_step_2.jpg?v=1778572705'
          },
          {
            title: 'Stronger Hair',
            text: 'Benefit from thicker, fuller-looking hair and a healthier-looking scalp. After use, simply wipe down your Cap with a damp cloth.',
            image: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_cap__etu_step_3.jpg?v=1778572705'
          }
        ]
      }
    };

    // "What You'll Notice" — outcome list rendered below the Easy-to-Use carousel.
    // Per-product list of {title,text}. (Figma 2572:2433 / 2933:3871.)
    // Optional `popup` makes the items list clickable and opens the shared
    // info popup (same pattern as descriptions.bulletsPopup).
    const whatYoullNotice = {
      'red-light-face-mask': {
        heading: "What You'll Notice",
        items: [
          {title: 'Brighter, more even tone', text: '98% of users reported even skin tone*'},
          {title: 'More radiant complexion', text: '96% of users reported glowing skin*'},
          {title: 'Younger looking skin', text: '74% of users reported younger looking skin*'}
        ],
        disclaimer: '*individual results may vary',
        popup: 'Based on customer reviews that explicitly mention at least one specific appearance-related outcome (n=50). Reviews may mention more than one outcome.'
      },
      'red-light-cap': {
        heading: "What You'll Notice",
        items: [
          {title: 'Supports Natural Hair Growth', text: '650nm red light helps support hair follicle activity and visible hair growth over time.'},
          {title: 'Thicker, Fuller-Looking Hair', text: 'Supports improved hair density for a fuller, more volumised appearance.'},
          {title: 'Strengthens Weak, Thinning Hair', text: 'Supports stronger, healthier-looking strands from root to tip.'},
          {title: 'Revitalise Your Scalp', text: 'Red light penetrates the scalp to nourish the roots, supporting healthy hair from the inside out.'}
        ],
        disclaimer: '*individual results may vary',
        popup: false
      }
    };

    // "Why BON CHARGE Wins" — comparison table rendered after .how-it-works-wrapper.
    // (Figma 2666:1382 / 2933:3159.) Per product: heading + column labels + rows.
    // Each row {label, us, them}; us/them accept inline HTML (e.g. <strong>, <br>).
    const whyWeWin = {
      'red-light-face-mask': {
        heading: 'Why BON CHARGE Wins',
        columnUs: 'BON CHARGE',
        columnThem: 'Other Masks',
        rows: [
          {label: 'Irradiance', us: '<strong>40.8 mW/cm</strong><br>Lab-measured and fully disclosed', them: "Most don't publish this number — or bury it in fine print"},
          {label: 'Wavelengths', us: '<strong>630 nm + 850 nm</strong><br>Research-backed red + near-infrared only', them: 'Some add blue light, which can disrupt sleep if used in the evening'},
          {label: 'LED coverage', us: '<strong>240 LEDs</strong><br>Designed for edge-to-edge coverage', them: 'Lower counts and uneven layouts leave patches untreated'},
          {label: 'Fit & contact', us: '<strong>Flexible silicone</strong><br>Contours to your face giving you full LED coverage', them: 'Rigid hard-shell designs sit away from skin, reducing efficiency'},
          {label: 'Eye Comfort', us: '<strong>Eye cups included</strong><br>Eyes open during sessions — scroll, read, watch', them: "Cut-outs or fixed shields that don't suit every face shape"}
        ]
      },
      'red-light-cap': {
        heading: 'Why BON CHARGE Wins',
        columnUs: 'BON CHARGE',
        columnThem: 'Other Brands',
        rows: [
          {label: 'Easy To Use', us: '<strong>Hands-free, wearable</strong><br>during daily activities', them: 'Bulky designs that require dedicated time'},
          {label: 'Session Time', us: '<strong>Just 10 minutes</strong><br>per session', them: 'Often longer, less convenient sessions'},
          {label: 'Design & Comfort', us: 'Soft, flexible cap designed for a cushioned fit', them: 'Rigid, helmet-style designs that may feel bulky or uncomfortable'},
          {label: 'Light Distribution', us: '<strong>Even light coverage</strong><br>across the scalp', them: 'Inconsistent or uneven coverage'},
          {label: 'Discreet, Wearable Design', us: 'Baseball cap style with concealed LEDs for everyday use', them: 'Visible, helmet-style devices not suitable for casual wear'}
        ]
      }
    };

    // Reviews section — overrides the existing `.pdp-reviews__title` heading and
    // adds an optional subtitle below. If `subtitlePopup` is configured, the
    // subtitle becomes clickable and opens a centered modal (Figma 2760:1375).
    // Defaults apply globally; per-product entries override individual fields.
    // Set `subtitle: ''` to hide the subtitle on a given product.
    const REVIEWS_DEFAULTS = {
      title: 'See What Others Are Saying:',
      subtitle: 'Real feedback from satisfied BON&nbsp;CHARGE customers:'
    };
    const reviewsConfig = {
      'red-light-face-mask': {
        title: 'Real feedback from satisfied BON&nbsp;CHARGE customers:',
        subtitle: '98% of users reported even skin tone, 96% glowing skin and 84% saw results in just 4 weeks*',
        subtitlePopup: 'Based on customer reviews that explicitly mention at least one specific appearance-related outcome (n=50). Reviews may mention more than one outcome.'
      }
      // 'red-light-cap': not configured — uses REVIEWS_DEFAULTS for title + subtitle
    };

    // #beforeAfter-Section restyle (Figma 2578:4267). Per-product `stats` line
    // injected under each slide's heading. If a product is not configured, the
    // section is left untouched.
    const beforeAfterConfig = {
      'red-light-face-mask': {
        stats: '98% of users reported even skin tone, 96% glowing skin and 84% saw results in just 4 weeks*',
        statsPopup: 'Based on customer reviews that explicitly mention at least one specific appearance-related outcome (n=50). Reviews may mention more than one outcome.'
      }
      // 'red-light-cap': not configured — section unchanged on Cap PDP
    };

    // Related products subtitle — text rendered directly under the
    // "You may also like" heading inside <product-recommendations>. The
    // recommendations block loads async, so the inner observer keeps
    // re-checking until the heading lands.
    const relatedProducts = {
      'red-light-face-mask': {
        subtitle: 'Boost your results with these targeted red light therapy products'
      },
      'red-light-cap': {
        subtitle: 'Boost your results with these targeted red light therapy products'
      }
    };

    // UGC video strip — "Real Results From Real Customers" block (Figma 2572:2342).
    // Inserted directly after .pdp-info-badges. Per-product list of videos with
    // optional caption rendered below each tile; tap a tile → lightbox plays
    // the video. Section is skipped if not configured.
    // Each entry: { src: 'mp4 url', caption: 'optional text below tile' }
    const ugc = {
      'red-light-face-mask': {
        headline: 'Real Results From Real Customers',
        videos: [
          {src: 'https://cdn.shopify.com/videos/c/o/v/2030d74de7184bee972650144917d6db.mp4', caption: 'Easy to use and fits seamlessly into your routine'},
          {src: 'https://cdn.shopify.com/videos/c/o/v/a85143e0fd6f4d98911c4fcd971a9664.mp4', caption: 'Reduces the appearance of fine lines and wrinkles'},
          {src: 'https://cdn.shopify.com/videos/c/o/v/c3aa0ee257c34219b65b9e98001e18b6.mp4', caption: 'My skin has never looked or felt this smooth'},
          {src: 'https://cdn.shopify.com/videos/c/o/v/99f76d1baaa64d7fab0f320e40a74248.mp4', caption: 'My skin looks brighter, fresher and more radiant'}
        ]
      }
    };

    // Awards banner — detected by the marker phrase "Our award-winning".
    // If the banner exists in the DOM, swap bg + badge per-product.
    // If it does not exist, synthesize one from cfg and insert above the
    // "You may also like" (related products) section.
    const awardsBanner = {
      'red-light-face-mask': {
        title: 'The Best in Its Class',
        subtitle: 'Our award-winning advanced beauty technology',
        background: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_face_mask__AwardsBanner__background.jpg?v=1778138257',
        badge: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_face_mask__AwardsBanner__badges.png?v=1778138947'
      },
      'red-light-cap': {
        title: 'The Best in Its Class',
        subtitle: 'Our award-winning advanced beauty technology',
        background: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_cap__AwardsBanner__background.jpg?v=1778139922',
        badge: 'https://cdn.shopify.com/s/files/1/2794/1798/files/pdp_cap__AwardsBanner__badges.png?v=1778139921'
      }
    };

    /* --------------------------------------------------------------------------
       Universal config (same for all redesigned PDPs)
       -------------------------------------------------------------------------- */
    const TRUST_BADGES = ['30-Day Easy Returns', '1-Year Warranty'];

    // Info badges — 2x2 grid of cream pills with icons (Figma 2572:1901).
    // Inserted after the existing .pdp-trust-badges__container.
    const INFO_BADGE_ICONS = {
      user: '<svg viewBox="0 0 16.2679 15.4545" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0.813399 14.6411C2.71332 12.626 5.29279 11.3876 8.13397 11.3876C10.9751 11.3876 13.5546 12.626 15.4545 14.6411M11.7943 4.47368C11.7943 6.4952 10.1555 8.13397 8.13397 8.13397C6.11245 8.13397 4.47368 6.4952 4.47368 4.47368C4.47368 2.45216 6.11245 0.813397 8.13397 0.813397C10.1555 0.813397 11.7943 2.45216 11.7943 4.47368Z" stroke="currentColor" stroke-width="1.62679" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      package: '<svg viewBox="0 0 17.0816 17.6605" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15.0481 4.9892L8.13424 8.83024M8.13424 8.83024L1.22037 4.9892M8.13424 8.83024L8.13427 16.5575M9.76106 16.0605L8.7663 16.6131C8.53562 16.7413 8.42028 16.8053 8.29813 16.8305C8.19002 16.8527 8.07852 16.8527 7.97041 16.8305C7.84826 16.8053 7.73292 16.7413 7.50223 16.6131L1.4831 13.2691C1.23947 13.1338 1.11765 13.0661 1.02895 12.9699C0.950475 12.8847 0.891089 12.7838 0.854761 12.6738C0.813696 12.5495 0.813696 12.4102 0.813696 12.1315V5.52905C0.813696 5.25035 0.813696 5.111 0.854761 4.98671C0.891089 4.87676 0.950475 4.77583 1.02895 4.69068C1.11765 4.59442 1.23947 4.52675 1.4831 4.3914L7.50223 1.04743C7.73291 0.919276 7.84826 0.855194 7.97041 0.830072C8.07852 0.807838 8.19002 0.807838 8.29813 0.830072C8.42028 0.855194 8.53562 0.919273 8.7663 1.04743L14.7854 4.39139C15.0291 4.52674 15.1509 4.59442 15.2396 4.69068C15.3181 4.77583 15.3774 4.87676 15.4138 4.98671C15.4548 5.111 15.4548 5.25035 15.4548 5.52905L15.4548 9.23696M4.47398 2.72979L11.7946 6.79677M11.3879 13.7106L13.0146 15.3374L16.2682 12.0839" stroke="currentColor" stroke-width="1.62679" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      truck: '<svg viewBox="0 0 17.8949 14.6411" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10.5742 3.25359H12.4753C12.6742 3.25359 12.7737 3.25359 12.8673 3.27606C12.9503 3.29599 13.0296 3.32885 13.1024 3.37345C13.1845 3.42375 13.2548 3.49409 13.3955 3.63477L16.7001 6.93939C16.8408 7.08007 16.9112 7.15041 16.9615 7.23249C17.0061 7.30527 17.0389 7.38461 17.0589 7.46761C17.0813 7.56122 17.0813 7.66069 17.0813 7.85964V10.1675C17.0813 10.5465 17.0813 10.736 17.0194 10.8854C16.9369 11.0847 16.7785 11.2431 16.5792 11.3256C16.4297 11.3876 16.2402 11.3876 15.8612 11.3876M11.7943 11.3876H10.5742M10.5742 11.3876V3.41627C10.5742 2.50518 10.5742 2.04963 10.3968 1.70164C10.2409 1.39554 9.99201 1.14667 9.68591 0.990708C9.33792 0.813398 8.88238 0.813398 7.97129 0.813398H3.41627C2.50518 0.813398 2.04963 0.813398 1.70164 0.990708C1.39554 1.14667 1.14667 1.39554 0.990708 1.70164C0.813398 2.04963 0.813398 2.50518 0.813398 3.41627V9.76076C0.813398 10.6592 1.54174 11.3876 2.44019 11.3876M10.5742 11.3876H7.32057M7.32057 11.3876C7.32057 12.7352 6.22806 13.8277 4.88038 13.8277C3.5327 13.8277 2.44019 12.7352 2.44019 11.3876M7.32057 11.3876C7.32057 10.0399 6.22806 8.94736 4.88038 8.94736C3.5327 8.94736 2.44019 10.0399 2.44019 11.3876M15.8612 11.7943C15.8612 12.9173 14.9508 13.8277 13.8277 13.8277C12.7047 13.8277 11.7943 12.9173 11.7943 11.7943C11.7943 10.6712 12.7047 9.76076 13.8277 9.76076C14.9508 9.76076 15.8612 10.6712 15.8612 11.7943Z" stroke="currentColor" stroke-width="1.62679" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      lock: '<svg viewBox="0 0 14.6411 16.2679" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.3876 6.50717V4.88038C11.3876 2.63425 9.5667 0.813397 7.32057 0.813397C5.07444 0.813397 3.25359 2.63425 3.25359 4.88038V6.50717M7.32057 10.1675V11.7943M4.7177 15.4545H9.92344C11.2901 15.4545 11.9734 15.4545 12.4954 15.1886C12.9545 14.9546 13.3278 14.5813 13.5618 14.1222C13.8277 13.6002 13.8277 12.9169 13.8277 11.5502V10.4115C13.8277 9.04484 13.8277 8.36152 13.5618 7.83954C13.3278 7.38039 12.9545 7.00709 12.4954 6.77314C11.9734 6.50717 11.2901 6.50717 9.92344 6.50717H4.7177C3.35107 6.50717 2.66775 6.50717 2.14576 6.77314C1.68661 7.00709 1.31331 7.38039 1.07936 7.83954C0.813397 8.36152 0.813397 9.04484 0.813397 10.4115V11.5502C0.813397 12.9169 0.813397 13.6002 1.07936 14.1222C1.31331 14.5813 1.68661 14.9546 2.14576 15.1886C2.66775 15.4545 3.35107 15.4545 4.7177 15.4545Z" stroke="currentColor" stroke-width="1.62679" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
    const INFO_BADGES = {
      default: [
        {icon: 'user', text: 'Lifetime Technical Support'},
        {icon: 'package', text: 'Easy Returns'},
        {icon: 'truck', text: 'Free Shipping'},
        {icon: 'lock', text: 'Secure Checkout'}
      ],
      us: [
        {icon: 'user', text: 'Lifetime Technical Support'},
        {icon: 'package', text: 'HSA/FSA eligible'},
        {icon: 'truck', text: 'Free Shipping'},
        {icon: 'lock', text: 'Secure Checkout'}
      ]
    };

    let handle = '{{ product.handle }}';
    if (handle.indexOf('{{') === 0) {
      const m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
      handle = m ? m[1] : null;
    }
    if (!handle) return;

    // Skip products that aren't configured anywhere.
    const isConfigured =
      Boolean(bundleProducts[handle]) ||
      Boolean(howItWorks[handle]) ||
      Boolean(descriptions[handle]) ||
      Boolean(details[handle]) ||
      Boolean(trustTexts[handle]);
    //if (!isConfigured) return;

    /* --------------------------------------------------------------------------
       Template detection — Mask uses one Shopify product template, Cap uses a
       different one with slightly different markup (notably the Easy-to-Use
       section). Read data-bch-template from the body.
         'product'              → Mask-style template (steps-images-carousel)
         'product.pd-product'   → Cap-style template (pdp_floor_details)
       -------------------------------------------------------------------------- */
    function detectTemplate() {
      if (document.body) {
        const t = document.body.getAttribute('data-bch-template');
        if (t) return t;
        if (document.body.getAttribute('data-template') === 'pd-product') return 'product.pd-product';
      }
      return 'product';
    }

    const template = detectTemplate();

    // Active storefront market — read from <body data-bch-market="...">.
    // Used by `byMarket(table)` to pick a market-specific config variant,
    // falling back to `table.default` when the active market has no entry.
    const market = (document.body && document.body.getAttribute('data-bch-market')) || 'default';
    const byMarket = (table) => (table && (table[market] || table.default)) || null;

    /* --------------------------------------------------------------------------
       Tag <html>/<body> with handle + per-product CSS vars
       (lets CSS read trust text via var(--pdp-trust))
       -------------------------------------------------------------------------- */
    function applyDocAttrs() {
      const root = document.documentElement;
      root.setAttribute('data-pdp-product', handle);
      if (trustTexts[handle]) {
        root.style.setProperty('--pdp-trust', "'" + String(trustTexts[handle]).replace(/'/g, "\\'") + "'");
      }
      if (document.body) {
        document.body.setAttribute('data-pdp-product', handle);
        document.body.setAttribute(
          'data-pdp-viewport',
          window.matchMedia('(max-width: 749.98px)').matches ? 'mobile' : 'desktop'
        );
      }
    }

    applyDocAttrs();
    if (!document.body) document.addEventListener('DOMContentLoaded', applyDocAttrs);

    // Keep data-pdp-viewport in sync if the user resizes across the breakpoint
    // (lets CSS swap layouts and JS read the current mode).
    window.matchMedia('(max-width: 749.98px)').addEventListener('change', (e) => {
      if (document.body) {
        document.body.setAttribute('data-pdp-viewport', e.matches ? 'mobile' : 'desktop');
      }
    });

    const bundleProduct = bundleProducts[handle] ?? null;

    async function loadProductCard(productHandle) {
      try {
        const response = await fetch(`/products/${productHandle}?view=card&show_rating=true`);
        if (!response.ok) return null;
        return await response.text();
      } catch (e) {
        return null;
      }
    }

    /* --------------------------------------------------------------------------
       Update routines
       -------------------------------------------------------------------------- */
    const updateProduct = () => {

      const updateTrustBadges = (badgesContainer) => {
        if (!badgesContainer) return;
        badgesContainer.innerHTML = '';
        TRUST_BADGES.forEach((text) => {
          const item = document.createElement('div');
          item.className = 'pdp-trust-badges__item';
          item.innerHTML =
            '<div class="pdp-trust-badges__content"><span class="pdp-trust-badges__text">' +
            text +
            '</span></div>';
          badgesContainer.appendChild(item);
        });
      };

      // Inject the cream-pill info-badges grid (Figma 2572:1901) directly after
      // the existing .pdp-trust-badges container.
      const injectInfoBadges = (anchor) => {
        if (!anchor) return false;
        const root = anchor.closest('.pdp-trust-badges') || anchor;
        if (root.parentNode.querySelector('.pdp-info-badges')) return true;
        const wrap = document.createElement('div');
        wrap.className = 'pdp-info-badges';
        wrap.innerHTML = (byMarket(INFO_BADGES) || []).map((b) =>
          '<div class="pdp-info-badges__item">' +
          '<span class="pdp-info-badges__icon">' + (INFO_BADGE_ICONS[b.icon] || '') + '</span>' +
          '<span class="pdp-info-badges__text">' + b.text + '</span>' +
          '</div>'
        ).join('');
        root.insertAdjacentElement('afterend', wrap);
        return true;
      };

      const updateFreeShippingText = (el) => {
        if (!el) return;
        el.textContent = el.textContent.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
      };

      const insertTitleSubtitle = (titleEl) => {
        const text = titleSubtitles[handle];
        if (!text || !titleEl) return false;
        if (titleEl.parentElement.querySelector('.pd-product-info__title-subtitle')) return true;
        const p = document.createElement('p');
        p.className = 'pd-product-info__title-subtitle';
        p.textContent = text;
        titleEl.after(p);
        return true;
      };

      // Hide #shopify-installments-cta inside <shopify-payment-terms>'s shadow DOM
      // (can't be reached by regular CSS — we have to inject a <style> into the shadow root).
      const hideInstallmentsCta = (host) => {
        if (!host || !host.shadowRoot) return false;
        const style = document.createElement('style');
        style.textContent = '#shopify-installments-cta { display: none !important; }';
        host.shadowRoot.appendChild(style);
        return true;
      };

      const updateDescriptionText = (el) => {
        if (!el) return;
        const desc = descriptions[handle];
        if (!desc) return;
        el.innerHTML = '<p>' + desc.paragraph + '</p>';
        const bulletList = document.createElement('ul');
        bulletList.className = 'pdp-bullets';
        bulletList.innerHTML = desc.bullets.map(b => '<li>' + b + '</li>').join('');
        if (desc.bulletsPopup) {
          bulletList.classList.add('pdp-bullets--clickable');
          bulletList.setAttribute('role', 'button');
          bulletList.setAttribute('tabindex', '0');
          bulletList.addEventListener('click', () => openInfoPopup(desc.bulletsPopup));
          bulletList.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openInfoPopup(desc.bulletsPopup);
            }
          });
        }
        el.appendChild(bulletList);

        // Stock badge — green check-circle + "In Stock | Limited Quantities Available"
        // (Figma node 2572:1880; same on all products.)
        const stockBadge = document.createElement('div');
        stockBadge.className = 'pdp-stock-badge';
        stockBadge.innerHTML =
          '<svg class="pdp-stock-badge__icon" viewBox="0 0 14.7194 14.7194" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M4.34892 7.35971L6.35612 9.36691L10.3705 5.35252M14.0504 7.35971C14.0504 11.0549 11.0549 14.0504 7.35971 14.0504C3.66457 14.0504 0.669065 11.0549 0.669065 7.35971C0.669065 3.66457 3.66457 0.669065 7.35971 0.669065C11.0549 0.669065 14.0504 3.66457 14.0504 7.35971Z" stroke="#55B705" stroke-width="1.33813" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span class="pdp-stock-badge__text">In Stock | Limited Quantities Available</span>';
        el.appendChild(stockBadge);
      };

      const buildCarouselThumbs = (host, swiper) => {
        if (host.querySelector('.pdp-media-thumbs')) return;
        const slideImgs = Array.from(host.querySelectorAll('.swiper-slide img'));
        if (slideImgs.length < 2) return;

        const wrap = document.createElement('div');
        wrap.className = 'pdp-media-thumbs';
        const chev =
          '<svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M11.25 5L6.25 10L11.25 15" stroke="currentColor" stroke-width="2" ' +
          'stroke-linecap="round" stroke-linejoin="round"/></svg>';

        wrap.innerHTML =
          '<button type="button" class="pdp-media-thumbs__nav pdp-media-thumbs__nav--prev" aria-label="Previous">' + chev + '</button>' +
          '<div class="pdp-media-thumbs__track"></div>' +
          '<button type="button" class="pdp-media-thumbs__nav pdp-media-thumbs__nav--next" aria-label="Next">' + chev + '</button>';

        const track = wrap.querySelector('.pdp-media-thumbs__track');
        const pickSmall = (img) => {
          const srcset = (img.getAttribute('srcset') || '').split(',')
            .map((s) => s.trim().split(/\s+/))
            .filter((p) => p[0])
            .map((p) => ({url: p[0], w: parseInt(p[1], 10) || 0}));
          if (srcset.length) {
            const small = srcset.filter((s) => s.w >= 165).sort((a, b) => a.w - b.w)[0];
            if (small) return small.url;
            return srcset[0].url;
          }
          return img.currentSrc || img.src || '';
        };

        slideImgs.forEach((img, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pdp-media-thumbs__item';
          btn.dataset.index = String(i);
          btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
          const t = document.createElement('img');
          t.src = pickSmall(img);
          t.alt = '';
          t.loading = 'lazy';
          btn.appendChild(t);
          btn.addEventListener('click', () => swiper.slideTo(i));
          track.appendChild(btn);
        });

        host.appendChild(wrap);

        const setActive = (idx) => {
          const items = track.querySelectorAll('.pdp-media-thumbs__item');
          items.forEach((b, i) => b.classList.toggle('is-active', i === idx));
          const active = items[idx];
          if (active) active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
        };
        setActive(swiper.activeIndex || 0);
        swiper.on('slideChange', () => setActive(swiper.activeIndex));

        // Chevrons advance the main carousel; setActive (wired to slideChange)
        // then scrolls the active thumb into view, so the strip follows along.
        // Wrap at both ends so the strip mirrors slider behaviour.
        const total = slideImgs.length;
        wrap.querySelector('.pdp-media-thumbs__nav--prev')
          .addEventListener('click', () => {
            const i = (swiper.activeIndex - 1 + total) % total;
            swiper.slideTo(i);
          });
        wrap.querySelector('.pdp-media-thumbs__nav--next')
          .addEventListener('click', () => {
            const i = (swiper.activeIndex + 1) % total;
            swiper.slideTo(i);
          });
      };

      const injectFdaBadge = (host) => {
        // FDA clearance is a US-specific claim — only show in the US market
        // (driven by <body data-bch-market="us">).
        if (!fdaCleared[handle] || market !== 'us') return;
        const firstSlide = host.querySelector('.swiper-slide');
        if (!firstSlide || firstSlide.querySelector('.pdp-fda-badge')) return;
        const badge = document.createElement('img');
        badge.src = 'https://cdn.shopify.com/s/files/1/2794/1798/files/FDA_cleared_icon_b4d813a5-5355-4ce5-b10c-e7b7822de2b7.png?v=1778486837';
        badge.alt = 'FDA Cleared';
        badge.className = 'pdp-fda-badge';
        badge.loading = 'lazy';
        firstSlide.appendChild(badge);
      };

      // The theme renders .awards-badges as a sibling of .swiper-wrapper inside
      // <product-media-carousel>, so it visually overlays every slide. Mirror
      // the FDA-badge behavior: only show on the first slide and hide once the
      // user swipes away.
      const bindAwardsBadgesToFirstSlide = (host, swiper) => {
        const badges = host.querySelector('.awards-badges');
        if (!badges) return;
        const sync = () => {
          badges.classList.toggle('is-hidden', (swiper.activeIndex || 0) !== 0);
        };
        sync();
        swiper.on('slideChange', sync);
      };

      const updateCarousel = (el) => {
        if (!el) return;
        const interval = setInterval(() => {
          const swiperEl = el.querySelector('.swiper') || el.querySelector('.swiper-container');
          if (swiperEl?.swiper) {
            clearInterval(interval);
            const swiper = swiperEl.swiper;
            const opts = {...swiper.params, slidesPerView: 1.15};
            swiper.destroy(true, true);
            const fresh = new Swiper(swiperEl, opts);
            buildCarouselThumbs(el, fresh);
            injectFdaBadge(el);
            bindAwardsBadgesToFirstSlide(el, fresh);
          }
        }, 50);
        setTimeout(() => clearInterval(interval), 5000);
      };

      const updateDetails = (el) => {
        if (!el) return;

        const collapse = el.querySelector('.accordion-collapse');
        if (collapse) collapse.classList.remove('show');
        const detailsAccordionButton = el.querySelector('button');
        if (detailsAccordionButton) {
          detailsAccordionButton.classList.remove('collapsed');
          detailsAccordionButton.classList.add('collapse');
        }

        const cfg = details[handle];
        if (!cfg) return;

        const detailsBody = el.querySelector('.accordion-body');
        if (!detailsBody) return;

        const existingH3 = detailsBody.querySelector('h3');
        if (existingH3 && cfg.heading) {
          existingH3.textContent = cfg.heading;
        }

        detailsBody.querySelectorAll('p').forEach(p => p.remove());
        let ref = existingH3;
        cfg.paragraphs.forEach((text) => {
          const p = document.createElement('p');
          p.textContent = text;
          if (ref) ref.after(p);
          else detailsBody.prepend(p);
          ref = p;
        });
      };

      // Cap-style PDPs render a separate .pdp-floor-details section that hosts
      // the FAQ accordion. Pull the FAQ content out and render it as a sibling
      // right after .pdp-accordion-items using the same <details>/<summary>
      // markup the mask theme ships natively (#bch-pdp-collapsible-faq), so
      // the existing theme CSS picks it up unchanged.
      const moveFloorFaqsToAccordion = () => {
        const floorDetails = document.querySelector('.pdp-floor-details');
        if (!floorDetails) return true;
        const accordionItems = document.querySelector('.pdp-accordion-items');
        if (!accordionItems) return false;
        if (document.getElementById('bch-pdp-collapsible-faq')) return true;

        const faqsRoot = floorDetails.querySelector('#pd-faqs') || floorDetails;
        const faqContent = faqsRoot.querySelector('.pd-faqs__content');
        // Move (not clone) the FAQ content — cloning would duplicate the ids
        // Bootstrap relies on for `data-bs-target`, and the originals (still
        // in the hidden floor-details) would be the ones the collapse
        // listeners toggle, breaking the visible nested accordions.
        const contentNodes = document.createDocumentFragment();
        if (faqContent) {
          faqContent.classList.add('twbs');
          contentNodes.appendChild(faqContent);
        } else {
          faqsRoot.querySelectorAll('.pd-faqs__description, .pd-faqs__header').forEach((n) => n.remove());
          while (faqsRoot.firstChild) contentNodes.appendChild(faqsRoot.firstChild);
        }
        // Belt-and-braces: strip any stray descriptions inside the moved tree.
        contentNodes.querySelectorAll &&
          contentNodes.querySelectorAll('.pd-faqs__description').forEach((n) => n.remove());

        const wrap = document.createElement('div');
        wrap.id = 'bch-pdp-collapsible-faq';
        wrap.className = 'product__accordion accordion quick-add-hidden';
        wrap.innerHTML =
          '<details id="bch-pdp-faq-details">' +
            '<summary tabindex="0">' +
              '<div class="summary__title">' +
                '<h2 class="h4 accordion__title inline-richtext">FAQ</h2>' +
              '</div>' +
              '<svg class="icon icon-caret" viewBox="0 0 10 6" aria-label="Click to Expand Content">' +
                '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/>' +
              '</svg>' +
            '</summary>' +
            '<div class="accordion__content rte" id="bch-pdp-faq-content"></div>' +
          '</details>';
        wrap.querySelector('.accordion__content').appendChild(contentNodes);
        accordionItems.after(wrap);
        floorDetails.style.display = 'none';
        return true;
      };

      const updateBestPaired = async (el) => {
        if (!bundleProduct) {
          el.style.display = 'none';
          return;
        }
        const cardHTML = await loadProductCard(bundleProduct.handle);
        if (!cardHTML) {
          // Bundle product missing/unavailable (e.g. 404). Hide the original
          // "Best Paired With" element so we don't fall back to its content.
          el.style.display = 'none';
          return;
        }

        // Parse the fetched product card to lift image, link, price, rating.
        // Config (bundleProduct.title) takes priority over the fetched card's
        // heading so the brand-facing bundle name can differ from the Shopify
        // product title (e.g. config "Full Face & Scalp Bundle" beats Shopify
        // "Radiance Duo Kit").
        const tmp = document.createElement('div');
        tmp.innerHTML = cardHTML;
        const cardImg = tmp.querySelector('.card__media img, .media img, img');
        const cardLink = tmp.querySelector('a[href*="/products/"]');
        const fetchedName = tmp.querySelector('.card__heading')?.textContent.trim() || '';
        const cardName = bundleProduct.title || fetchedName;
        const variantInput = tmp.querySelector('form[action*="/cart/add"] input[name="id"], .product-variant-id');
        const variantId =
          (variantInput && variantInput.value) ||
          tmp.querySelector('[data-variant-id]')?.getAttribute('data-variant-id') ||
          '';
        const cardPrice = tmp.querySelector('.price');
        const priceMain = cardPrice?.querySelector('.price-item--sale, .price-item--regular')?.textContent.trim() || '';
        let priceCompare = cardPrice?.querySelector('.price-item--last s, .price-item--compare, s.price-item')?.textContent.trim() || '';
        const ratingWrap = tmp.querySelector('.rating-wrapper');

        // Treat any compare-at that parses to <= 0 (e.g. "$0 USD", "0,00 €")
        // as missing — common when a product has no compare_at_price set.
        const parseAmount = (s) => {
          if (!s) return 0;
          // Strip currency symbols/codes/whitespace, keep digits + separators.
          const cleaned = String(s).replace(/[^\d.,-]/g, '');
          // If both `.` and `,` appear, the LAST one is the decimal separator;
          // strip the other (thousands grouping).
          const lastDot = cleaned.lastIndexOf('.');
          const lastComma = cleaned.lastIndexOf(',');
          let normalized = cleaned;
          if (lastDot >= 0 && lastComma >= 0) {
            normalized = lastComma > lastDot
              ? cleaned.replace(/\./g, '').replace(',', '.')
              : cleaned.replace(/,/g, '');
          } else if (lastComma >= 0 && lastDot < 0) {
            // Only commas — assume European decimal.
            normalized = cleaned.replace(',', '.');
          }
          const n = parseFloat(normalized);
          return isNaN(n) ? 0 : n;
        };
        if (parseAmount(priceCompare) <= 0) priceCompare = '';

        // If we still have no compare-at, derive it from savePercent + priceMain
        // (original = main / (1 - percent/100)). Preserve the format of priceMain
        // by replacing only its numeric portion.
        if (!priceCompare && priceMain && bundleProduct.savePercent) {
          const num = parseAmount(priceMain);
          const pct = parseFloat(bundleProduct.savePercent);
          if (num > 0 && pct > 0 && pct < 100) {
            // Round up to the nearest whole unit so the strikethrough always
            // shows a clean price (e.g. $749.47 → $750.00).
            const original = Math.ceil(num / (1 - pct / 100));
            // Detect whether priceMain uses comma decimal (e.g. "749,00 €").
            const numMatch = priceMain.match(/[\d.,]+/);
            if (numMatch) {
              const sample = numMatch[0];
              const sampleLastComma = sample.lastIndexOf(',');
              const sampleLastDot = sample.lastIndexOf('.');
              const useComma = sampleLastComma > sampleLastDot;
              const formatted = useComma
                ? original.toFixed(2).replace('.', ',')
                : original.toFixed(2);
              priceCompare = priceMain.replace(/[\d.,]+/, formatted);
            }
          }
        }

        const bundleHref =
          cardLink?.getAttribute('href') || ('/products/' + bundleProduct.handle);
        const imgSrc = cardImg ? (cardImg.currentSrc || cardImg.src || '') : '';
        const imgAlt = cardImg ? (cardImg.alt || cardName) : cardName;

        const ribbon = bundleProduct.savePercent
          ? '<span class="pdp-bundle-cs__ribbon">' +
          '<span class="pdp-bundle-cs__ribbon-prefix">Save</span>' +
          '<span class="pdp-bundle-cs__ribbon-amt">' + bundleProduct.savePercent + '%</span>' +
          '</span>'
          : '';

        const priceLine = (priceMain || priceCompare)
          ? '<p class="pdp-bundle-cs__price">' +
          (priceMain ? '<span class="pdp-bundle-cs__price-main">' + priceMain + '</span>' : '') +
          (priceCompare ? ' <s class="pdp-bundle-cs__price-compare">' + priceCompare + '</s>' : '') +
          (bundleProduct.savePercent ? ' <span class="pdp-bundle-cs__price-save">(Save ' + bundleProduct.savePercent + '%)</span>' : '') +
          '</p>'
          : '';

        const wrap = document.createElement('div');
        wrap.classList.add('pdp-bundle-and-save-wrapper', 'pdp-bundle-cs');
        const ctaText = bundleProduct.ctaText || 'ADD TO CART +';
        wrap.innerHTML =
          '<div class="pdp-bundle-cs__head">' +
          (bundleProduct.heading ? '<h3 class="pdp-bundle-cs__heading">' + bundleProduct.heading + '</h3>' : '') +
          (bundleProduct.subheading ? '<p class="pdp-bundle-cs__subheading">' + bundleProduct.subheading + '</p>' : '') +
          '</div>' +
          '<div class="pdp-bundle-cs__card">' +
          ribbon +
          '<a class="pdp-bundle-cs__media" href="' + bundleHref + '">' +
            (imgSrc ? '<img class="pdp-bundle-cs__image" src="' + imgSrc + '" alt="' + imgAlt + '" loading="lazy">' : '') +
          '</a>' +
          '<h4 class="pdp-bundle-cs__name">' + cardName + '</h4>' +
          (ratingWrap ? '<div class="pdp-bundle-cs__rating">' + ratingWrap.outerHTML + '</div>' : '') +
          (bundleProduct.text ? '<p class="pdp-bundle-cs__text">' + bundleProduct.text + '</p>' : '') +
          priceLine +
          (variantId
            ? '<button type="button" class="pdp-bundle-cs__cta" data-variant-id="' + variantId + '">' + ctaText + '</button>'
            : '<a class="pdp-bundle-cs__cta" href="' + bundleHref + '">' + ctaText + '</a>') +
          '</div>';

        if (variantId) {
          const ctaBtn = wrap.querySelector('.pdp-bundle-cs__cta');
          ctaBtn.addEventListener('click', async () => {
            if (ctaBtn.disabled) return;
            ctaBtn.disabled = true;
            const original = ctaBtn.textContent;
            ctaBtn.textContent = 'Adding...';
            try {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}]})
              });
              if (!res.ok) throw new Error('add failed');
              // Stay on PDP. Refresh the cart icon bubble + ping any listening
              // cart drawer/notification components, then show transient feedback.
              window.SLIDECART_UPDATE(window.SLIDECART_OPEN);
              try {
                const cartRes = await fetch('/cart.js', {headers: {'Accept': 'application/json'}});
                const cart = await cartRes.json();
                document.dispatchEvent(new CustomEvent('cart:added', {detail: cart}));
                document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
              } catch (_) { /* non-fatal */ }
              ctaBtn.textContent = 'Added ✓';
              setTimeout(() => {
                ctaBtn.textContent = original;
                ctaBtn.disabled = false;
              }, 2000);
            } catch (err) {
              ctaBtn.disabled = false;
              ctaBtn.textContent = original;
            }
          });
        }

        el.replaceWith(wrap);
      };

      const updateSab = (el) => {
        const sabCont = sabContent[handle] ?? null;
        if (!sabCont) return;
        const html = `
          <h3 class="sab-block--title">${sabCont.title}</h3>
          <div class="sab-block--text">${sabCont.text}</div>
          <h3 class="sab-block--title">${sabCont.title2}</h3>
        `;
        const sabMember = el.querySelector('.text-image-video__heading')?.innerText;
        if (sabMember === 'Dr Shabana Daya') {
          const byline = el.querySelector('.text-image-video__byline');
          if (byline) {
            byline.innerText =
              'Physician in Integrative & Aesthetic Medicine | Diploma in Clinical Dermatology | BON CHARGE Scientific Advisor';
          }
        }
        const blockEl = document.createElement('div');
        blockEl.classList.add('sab-block');
        blockEl.innerHTML = html;
        el.before(blockEl);
      };

      // Re-skin the .section-banner-sab section with the "Trusted By Leading
      // Experts" Figma design. Preserves the existing <deferred-media>/<img>
      // so the play-on-click video player still works.
      const updateSabBanner = (banner) => {
        const cfg = sabBanner[handle];
        if (!cfg || banner.classList.contains('pdp-sab')) return;
        const media = banner.querySelector('deferred-media') || banner.querySelector('img');
        const wrap = document.createElement('div');
        wrap.classList.add('pdp-sab__inner');
        wrap.innerHTML =
          '<h3 class="pdp-sab__heading">' + cfg.heading + '</h3>' +
          '<div class="pdp-sab__expert">' +
          '<p class="pdp-sab__name">' + cfg.name + '</p>' +
          (cfg.role ? '<p class="pdp-sab__role">' + cfg.role + '</p>' : '') +
          '</div>' +
          '<div class="pdp-sab__media-slot"></div>' +
          (cfg.quote ? '<blockquote class="pdp-sab__quote">' + cfg.quote + '</blockquote>' : '');
        const slot = wrap.querySelector('.pdp-sab__media-slot');
        if (media && slot) slot.appendChild(media);
        banner.classList.add('pdp-sab');
        banner.replaceChildren(wrap);
      };

      // Replace the .pdp-reviews__title heading text and append an optional
      // subtitle below. Subtitle is clickable (opens popup) iff subtitlePopup
      // is configured. Idempotent.
      const updateReviews = (reviewsEl) => {
        const titleWrap = reviewsEl.querySelector('.pdp-reviews__title');
        if (!titleWrap || titleWrap.dataset.pdpReviewsUpdated) return;

        const cfg = reviewsConfig[handle] || {};
        const title = ('title' in cfg) ? cfg.title : REVIEWS_DEFAULTS.title;
        const subtitle = ('subtitle' in cfg) ? cfg.subtitle : REVIEWS_DEFAULTS.subtitle;
        const popup = cfg.subtitlePopup;
        const titlePopup = cfg.titlePopup;

        titleWrap.dataset.pdpReviewsUpdated = 'true';

        const h3 = titleWrap.querySelector('h3, h2, h4');
        if (h3 && title) h3.innerHTML = title;
        if (h3 && titlePopup) {
          h3.classList.add('pdp-reviews__heading--clickable');
          h3.setAttribute('role', 'button');
          h3.setAttribute('tabindex', '0');
          h3.addEventListener('click', () => openInfoPopup(titlePopup));
          h3.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openInfoPopup(titlePopup);
            }
          });
        }

        if (subtitle) {
          const subEl = document.createElement('p');
          subEl.className = 'pdp-reviews__subtitle';
          subEl.innerHTML = subtitle;
          if (popup) {
            subEl.classList.add('pdp-reviews__subtitle--clickable');
            subEl.setAttribute('role', 'button');
            subEl.setAttribute('tabindex', '0');
            subEl.addEventListener('click', () => openInfoPopup(popup));
            subEl.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openInfoPopup(popup);
              }
            });
          }
          titleWrap.appendChild(subEl);
        }
      };

      const openInfoPopup = (text) => {
        // Avoid stacking multiple instances if double-clicked.
        if (document.querySelector('.pdp-popup')) return;
        const overlay = document.createElement('div');
        overlay.className = 'pdp-popup';
        overlay.innerHTML =
          '<div class="pdp-popup__card" role="dialog" aria-modal="true">' +
          '<button type="button" class="pdp-popup__close" aria-label="Close">×</button>' +
          '<p class="pdp-popup__text">' + text + '</p>' +
          '</div>';
        const close = () => {
          document.removeEventListener('keydown', onKey);
          overlay.remove();
        };
        const onKey = (e) => {
          if (e.key === 'Escape') close();
        };
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) close();
        });
        overlay.querySelector('.pdp-popup__close').addEventListener('click', close);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(overlay);
        // Focus the close button so Escape works immediately.
        overlay.querySelector('.pdp-popup__close').focus();
      };

      const openVideoPopup = (url) => {
        if (document.querySelector('.pdp-popup')) return;
        const overlay = document.createElement('div');
        overlay.className = 'pdp-popup pdp-popup--video';
        overlay.innerHTML =
          '<div class="pdp-popup__card pdp-popup__card--video" role="dialog" aria-modal="true">' +
          '<button type="button" class="pdp-popup__close" aria-label="Close">×</button>' +
          '<video class="pdp-popup__video" src="' + url + '" controls autoplay playsinline></video>' +
          '</div>';
        const close = () => {
          document.removeEventListener('keydown', onKey);
          overlay.remove();
        };
        const onKey = (e) => { if (e.key === 'Escape') close(); };
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
        overlay.querySelector('.pdp-popup__close').addEventListener('click', close);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(overlay);
        overlay.querySelector('.pdp-popup__close').focus();
      };

      // Restyle #beforeAfter-Section to match the Figma redesign and inject the
      // configured per-product stats line under each slide's heading. Idempotent.
      const updateBeforeAfter = (el) => {
        const cfg = beforeAfterConfig[handle];
        if (!cfg || el.dataset.pdpBaUpdated) return;
        el.dataset.pdpBaUpdated = 'true';
        el.classList.add('pdp-ba');
        if (cfg.stats) {
          el.querySelectorAll('.carousel-item').forEach((item) => {
            const headWrap = item.querySelector('.container-lg .text-center')
              || item.querySelector('.container-lg > div')
              || item.querySelector('.container-lg');
            if (!headWrap || headWrap.querySelector('.pdp-ba__stats')) return;
            const stats = document.createElement('p');
            stats.className = 'pdp-ba__stats';
            stats.textContent = cfg.stats;
            if (cfg.statsPopup) {
              stats.classList.add('pdp-ba__stats--clickable');
              stats.setAttribute('role', 'button');
              stats.setAttribute('tabindex', '0');
              stats.addEventListener('click', () => openInfoPopup(cfg.statsPopup));
              stats.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  openInfoPopup(cfg.statsPopup);
                }
              });
            }
            headWrap.appendChild(stats);
          });
        }

        // Build per-slide before/after thumbs + small dot indicators (Figma 2741:2661).
        // Click delegates to the existing Bootstrap carousel-indicators buttons so
        // we don't reimplement the slide logic — just dispatch a click on the
        // hidden indicator that already has data-bs-slide-to wiring.
        const carousel = el.querySelector('.beforeAfterSliders.carousel') || el.querySelector('.carousel');
        if (carousel && !el.querySelector('.pdp-ba__nav')) {
          const items = Array.from(carousel.querySelectorAll('.carousel-item'));
          const indicatorBtns = Array.from(
            el.querySelectorAll('.carousel-indicators button[data-bs-slide-to]')
          );
          const thumbsHtml = items.map((item, i) => {
            const beforeImg = item.querySelector('.before-image img');
            const afterImg = item.querySelector('.after-image img');
            const beforeSrc = beforeImg ? (beforeImg.currentSrc || beforeImg.src || '') : '';
            const afterSrc = afterImg ? (afterImg.currentSrc || afterImg.src || '') : '';
            return (
              '<button type="button" class="pdp-ba__thumb' + (i === 0 ? ' is-active' : '') + '" data-slide-index="' + i + '" aria-label="Show slide ' + (i + 1) + '">' +
              '<span class="pdp-ba__thumb-half">' + (beforeSrc ? '<img src="' + beforeSrc + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="pdp-ba__thumb-half">' + (afterSrc ? '<img src="' + afterSrc + '" alt="" loading="lazy">' : '') + '</span>' +
              '</button>'
            );
          }).join('');
          const dotsHtml = items.map((_, i) => (
            '<button type="button" class="pdp-ba__dot' + (i === 0 ? ' is-active' : '') + '" data-slide-index="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>'
          )).join('');
          const navWrap = document.createElement('div');
          navWrap.className = 'pdp-ba__nav';
          navWrap.innerHTML =
            '<div class="pdp-ba__thumbs">' + thumbsHtml + '</div>' +
            '<div class="pdp-ba__dots">' + dotsHtml + '</div>';
          const sliders = el.querySelector('#beforeAfterSliders') || carousel.parentNode;
          sliders.appendChild(navWrap);

          const goTo = (i) => {
            const btn = indicatorBtns[i];
            if (btn) btn.click();
          };
          navWrap.querySelectorAll('.pdp-ba__thumb, .pdp-ba__dot').forEach((b) => {
            b.addEventListener('click', () => {
              const i = parseInt(b.getAttribute('data-slide-index'), 10);
              if (!Number.isNaN(i)) goTo(i);
            });
          });
          const setActive = (idx) => {
            navWrap.querySelectorAll('.pdp-ba__thumb').forEach((t, i) => t.classList.toggle('is-active', i === idx));
            navWrap.querySelectorAll('.pdp-ba__dot').forEach((d, i) => d.classList.toggle('is-active', i === idx));
          };
          carousel.addEventListener('slid.bs.carousel', (ev) => {
            const idx = (ev && typeof ev.to === 'number')
              ? ev.to
              : items.findIndex((it) => it.classList.contains('active'));
            if (idx >= 0) setActive(idx);
          });
        }
      };

      const findAwardsBanner = () => {
        // Banner has no stable id/class — locate it by the marker phrase
        // "Our award-winning", then walk up to the nearest ancestor that
        // carries the inline background-image (the visible banner wrapper).
        const all = document.querySelectorAll('p, h1, h2, h3, h4, div, span');
        for (const node of all) {
          const txt = node.textContent;
          if (!txt || !txt.toLowerCase().includes('our award-winning')) continue;
          let cur = node;
          while (cur && cur !== document.body) {
            const s = cur.getAttribute('style') || '';
            if (/background[^;]*url\(/i.test(s)) return cur;
            cur = cur.parentElement;
          }
        }
        return null;
      };

      const updateAwardsBanner = (el) => {
        el.classList.add('section-award-badges');
        const cfg = awardsBanner[handle];
        if (!cfg) return;
        if (cfg.background) {
          el.style.backgroundImage = "url('" + cfg.background + "')";
        }
        if (cfg.title) {
          const title = el.querySelector('h1, h2, h3');
          if (title) title.textContent = cfg.title;
        }
        if (cfg.subtitle) {
          const subtitle = el.querySelector('p');
          if (subtitle) subtitle.textContent = cfg.subtitle;
        }
        if (cfg.badge) {
          const badge = el.querySelector('img');
          if (badge) {
            badge.src = cfg.badge;
            badge.removeAttribute('srcset');
          }
        }
      };

      const insertAwardsBanner = (cfg) => {
        const related = document.querySelector('.shopify-section.related-products');
        if (!related) return false;
        const div = document.createElement('div');
        div.className = 'section-award-badges section-award-badges--synth';
        if (cfg.background) {
          div.style.backgroundImage = "url('" + cfg.background + "')";
        }
        div.innerHTML =
          '<div class="twbs"><div class="container"><div class="row">' +
            '<div class="col-sm-12 col-lg-8 px-sm-0 px-lg-4 py-lg-6 py-0">' +
              (cfg.title ? '<h2 class="text-left h1 mt-4">' + cfg.title + '</h2>' : '') +
              (cfg.subtitle ? '<p>' + cfg.subtitle + '</p>' : '') +
              '<div class="py-2">' +
                (cfg.badge ? '<img src="' + cfg.badge + '" alt="">' : '') +
              '</div>' +
            '</div>' +
          '</div></div></div>';
        related.parentElement.insertBefore(div, related);
        return true;
      };

      const findEasyToUseSection = () => {
        // Cap-style template wraps multiple "floors" in a single .shopify-section
        // (easy-to-use + the-science + pd-faqs). Match the inner #easy-to-use floor
        // directly so we don't drag the science/FAQ floors along when we move it.
        if (template === 'product.pd-product') {
          return document.getElementById('easy-to-use');
        }
        const sections = document.querySelectorAll('.shopify-section');
        for (const el of sections) {
          // Skip sections that wrap <product-info> — product copy can prose-match
          // "easy to use" and we'd then innerHTML-replace product-info by mistake.
          if (el.querySelector('product-info')) continue;
          if (el.innerText.toLowerCase().includes('easy to use')) {
            return el;
          }
        }
        return null;
      };

      // Read step content from the original theme markup.
      // Mask uses `.steps-images-carousel__step`, Cap uses `#js-easy-to-use-slide-N`.
      // Returns a 3-entry array of { title, text, image } (empty strings if not found).
      const readOriginalEtuSteps = (el) => {
        const out = [];
        const maskSteps = document.querySelectorAll(
          '.steps-images-carousel__steps:not(.hide-desktop-and-up) .steps-images-carousel__step'
        );
        if (maskSteps.length) {
          // Per-step images live in the parallel imagery carousel, not inside the
          // step nodes themselves. Gather them in order to pair with each step.
          const maskImages = Array.from(
            document.querySelectorAll('.steps-images-carousel__image img')
          ).map((img) => img.currentSrc || img.src || '');
          Array.from(maskSteps).slice(0, 3).forEach((s, i) => {
            const titleEl = s.querySelector('.steps-images-carousel__step__title');
            const textEl = s.querySelector(
              '.steps-images-carousel__step__desc-inner p, .steps-images-carousel__step__desc p'
            );
            let title = titleEl ? titleEl.textContent.trim() : '';
            title = title.replace(/^\d+\.\s*/, ''); // drop leading "1. "
            out.push({
              title,
              text: textEl ? textEl.textContent.trim() : '',
              image: maskImages[i] || maskImages[0] || ''
            });
          });
          while (out.length < 3) out.push({title: '', text: '', image: ''});
          return out;
        }
        // Cap fallback
        const baseImgEl = el.querySelector('#js-easy-to-use-img img');
        const baseImg = baseImgEl ? (baseImgEl.currentSrc || baseImgEl.src || '') : '';
        for (let i = 1; i <= 3; i++) {
          const slide = el.querySelector('#js-easy-to-use-slide-' + i);
          if (!slide) {
            out.push({title: '', text: '', image: baseImg});
            continue;
          }
          const titleEl = slide.querySelector('h2,h3,h4,h5,h6');
          const textEl = slide.querySelector('p');
          out.push({
            title: titleEl ? titleEl.textContent.trim() : '',
            text: textEl ? textEl.textContent.trim() : slide.textContent.trim(),
            image: baseImg
          });
        }
        return out;
      };

      const getProductFirstImage = () => {
        const sources = [
          '.pd-product-media-gallery .swiper-slide img',
          '.pd-product-media-gallery img',
          'product-media-carousel img',
          '.product__media-list img'
        ];
        for (const sel of sources) {
          const img = document.querySelector(sel);
          const src = img && (img.currentSrc || img.src || img.getAttribute('data-src'));
          if (src) return src;
        }
        return '';
      };

      const updateEasyToUse = (el) => {
        el.classList.add('easy-to-use');
        el.classList.add('pdp-etu');

        const cfg = easyToUseConfig[handle] || null;
        const fallbacks = readOriginalEtuSteps(el);
        const stepsCfg = (cfg && cfg.steps) || [];
        // Per-step image: cfg step.image first, then the theme's original
        // step image as a fallback.
        const steps = [0, 1, 2].map((i) => {
          const c = stepsCfg[i] || {};
          const f = fallbacks[i] || {};
          return {
            title: (c.title != null ? c.title : f.title) || '',
            text: (c.text != null ? c.text : f.text) || '',
            image: (c.image != null ? c.image : f.image) || ''
          };
        });

        const productImg = getProductFirstImage();
        const iconBlocks = (cfg && cfg.iconBlocks) || [];

        const iconsHtml = iconBlocks.slice(0, 3).map((b, i) => {
          const visual = i === 0 && productImg
            ? '<img class="pdp-etu__nav-img" src="' + productImg + '" alt="">'
            : '<span class="pdp-etu__nav-icon">' + (b.iconSvg || '') + '</span>';
          return (
            '<button type="button" class="pdp-etu__nav" data-step="' + i + '">' +
            visual +
            '<span class="pdp-etu__nav-label">' + (i + 1) + '. ' + (b.label || '') + '</span>' +
            '</button>'
          );
        }).join('');

        const slidesHtml = steps.map((s, i) => (
          '<div class="pdp-etu__slide" data-step="' + i + '">' +
          (s.image ? '<img class="pdp-etu__slide-img" src="' + s.image + '" alt="">' : '') +
          '<div class="pdp-etu__step">' +
          '<p class="pdp-etu__step-title">' +
          '<span class="pdp-etu__step-num">' + (i + 1) + '.</span> ' +
          s.title +
          '</p>' +
          '<p class="pdp-etu__step-text">' + s.text + '</p>' +
          '</div>' +
          '</div>'
        )).join('');

        const dotsHtml = steps.map((_, i) => (
          '<button type="button" class="pdp-etu__dot" data-step="' + i +
          '" aria-label="Go to slide ' + (i + 1) + '"></button>'
        )).join('');

        el.innerHTML =
          '<div class="pdp-etu__head">' +
          (cfg && cfg.title ? '<p class="pdp-etu__title">' + cfg.title + '</p>' : '') +
          (cfg && cfg.subtitle ? '<p class="pdp-etu__subtitle">' + cfg.subtitle + '</p>' : '') +
          '</div>' +
          (iconsHtml ? '<div class="pdp-etu__nav-row">' + iconsHtml + '</div>' : '') +
          '<div class="pdp-etu__slides">' + slidesHtml + '</div>' +
          '<div class="pdp-etu__dots">' + dotsHtml + '</div>';

        // Carousel: slides live in a horizontal scroll-snap track. Clicking a
        // nav block or dot scrolls the track to that slide; scroll position
        // drives which nav block + dot is highlighted.
        const navs = el.querySelectorAll('.pdp-etu__nav');
        const dots = el.querySelectorAll('.pdp-etu__dot');
        const track = el.querySelector('.pdp-etu__slides');
        const slideEls = el.querySelectorAll('.pdp-etu__slide');
        const setActive = (idx) => {
          navs.forEach((n, i) => n.classList.toggle('is-active', i === idx));
          dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        };
        const scrollTo = (i) => {
          const target = slideEls[i];
          if (target && track) track.scrollTo({left: target.offsetLeft, behavior: 'smooth'});
        };
        navs.forEach((n, i) => n.addEventListener('click', () => scrollTo(i)));
        dots.forEach((d, i) => d.addEventListener('click', () => scrollTo(i)));
        if (track) {
          let scrollDebounce;
          track.addEventListener('scroll', () => {
            clearTimeout(scrollDebounce);
            scrollDebounce = setTimeout(() => {
              const w = slideEls[0] ? slideEls[0].offsetWidth : 1;
              const idx = Math.round(track.scrollLeft / w);
              setActive(Math.min(Math.max(idx, 0), slideEls.length - 1));
            }, 60);
          }, {passive: true});
        }
        setActive(0);

        const productInfo = document.querySelector('product-info');
        if (productInfo) productInfo.after(el);
      };

      const addHowItWorks = () => {
        const hiw = howItWorks[handle] ?? null;
        if (!hiw) return;
        const ratingWrapper = document.querySelector(
          '.pd-product-info .product__info-wrapper > .product__info-container > .rating-wrapper'
        )?.cloneNode(true);
        const featuresHtml = (hiw.features && hiw.features.length) ? `
          <div class="how-it-works-features">
            ${hiw.features.map(f => `
            <div class="how-it-works-features__item">
              <div class="how-it-works-features__icon">${f.iconSvg || ''}</div>
              <div class="how-it-works-features__body">
                <h5 class="how-it-works-features__title">${f.title}</h5>
                <p class="how-it-works-features__text">${f.text}</p>
              </div>
            </div>
            `).join('')}
          </div>
        ` : '';
        const html = `
          <div class="how-it-works">
            ${hiw.image ? `<div class="how-it-works--image"><img src="${hiw.image}" alt="" /></div>` : ''}
            <div class="how-it-works--content">
              <div class="how-it-works--rating">${ratingWrapper?.outerHTML ?? ''}</div>
              <h3 class="how-it-works--title">${hiw.title}</h3>
              <div class="how-it-works--text">${hiw.text}</div>
            </div>
          </div>
          ${featuresHtml}
          <h4 class="how-it-works--itemsTitle">${hiw.itemsTitle}</h4>
          <div class="how-it-works-items">
            ${hiw.items.map(item => `
            <div class="how-it-works-items__item">
              <div class="how-it-works-items__item-icon">${item.icon}</div>
              <h5 class="how-it-works-items__item-title">${item.title}</h5>
              <p class="how-it-works-items__item-text">${item.text}</p>
            </div>
            `).join('')}
          </div>
        `;
        const el = document.createElement('div');
        el.classList.add('how-it-works-wrapper');
        el.innerHTML = html;

        const easyToUse = document.querySelector('.easy-to-use');
        if (easyToUse) easyToUse.after(el);
      };

      // "What You'll Notice" — outcome list inserted directly BEFORE .easy-to-use.
      const addWhatYoullNotice = () => {
        const cfg = whatYoullNotice[handle];
        if (!cfg || document.querySelector('.pdp-wyn')) return;
        const checkIcon =
          '<svg viewBox="0 0 14.7194 14.7194" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M4.34892 7.35971L6.35612 9.36691L10.3705 5.35252M14.0504 7.35971C14.0504 11.0549 11.0549 14.0504 7.35971 14.0504C3.66457 14.0504 0.669065 11.0549 0.669065 7.35971C0.669065 3.66457 3.66457 0.669065 7.35971 0.669065C11.0549 0.669065 14.0504 3.66457 14.0504 7.35971Z" stroke="currentColor" stroke-width="1.33813" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
        const itemsHtml = cfg.items.map((it) => (
          '<div class="pdp-wyn__item">' +
          '<div class="pdp-wyn__head">' +
          '<span class="pdp-wyn__icon">' + checkIcon + '</span>' +
          '<h5 class="pdp-wyn__title">' + it.title + '</h5>' +
          '</div>' +
          '<p class="pdp-wyn__text">' + it.text + '</p>' +
          '</div>'
        )).join('');
        const wrap = document.createElement('div');
        wrap.classList.add('pdp-wyn');
        wrap.innerHTML =
          '<h3 class="pdp-wyn__heading">' + cfg.heading + '</h3>' +
          '<div class="pdp-wyn__list">' + itemsHtml + '</div>' +
          (cfg.disclaimer ? '<p class="pdp-wyn__disclaimer">' + cfg.disclaimer + '</p>' : '');
        if (cfg.popup) {
          const list = wrap.querySelector('.pdp-wyn__list');
          list.classList.add('pdp-wyn__list--clickable');
          list.setAttribute('role', 'button');
          list.setAttribute('tabindex', '0');
          list.addEventListener('click', () => openInfoPopup(cfg.popup));
          list.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openInfoPopup(cfg.popup);
            }
          });
        }
        const easyToUse = document.querySelector('.easy-to-use');
        if (easyToUse) easyToUse.before(wrap);
      };

      // "Real Results From Real Customers" UGC strip (Figma 2572:2342) inserted
      // directly after .pdp-info-badges. Each tile is a square video poster with
      // a play overlay; click opens the lightbox via openVideoPopup.
      const addUgc = (anchor) => {
        const cfg = ugc[handle];
        if (!cfg || !cfg.videos || !cfg.videos.length) return;
        if (document.querySelector('.pdp-ugc')) return;
        // Accept legacy `videos: ['url', ...]` and the richer
        // `videos: [{src, caption}, ...]` shape.
        const items = cfg.videos.map((v) =>
          typeof v === 'string' ? {src: v, caption: ''} : v
        );
        const playSvg =
          '<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<circle cx="11" cy="11" r="10.25" stroke="currentColor" stroke-width="1.5" fill="rgba(0,0,0,0.35)"/>' +
          '<path d="M9 7.5L15 11L9 14.5V7.5Z" fill="currentColor"/></svg>';
        const slidesHtml = items.map((v, i) => (
          '<div class="pdp-ugc__slide">' +
            '<button type="button" class="pdp-ugc__item" data-index="' + i + '" aria-label="Play video ' + (i + 1) + '">' +
              '<video class="pdp-ugc__video" src="' + v.src + '#t=0.1" muted playsinline preload="metadata"></video>' +
              '<span class="pdp-ugc__play">' + playSvg + '</span>' +
            '</button>' +
            (v.caption ? '<p class="pdp-ugc__caption">' + v.caption + '</p>' : '') +
          '</div>'
        )).join('');
        const wrap = document.createElement('section');
        wrap.className = 'pdp-ugc';
        wrap.innerHTML =
          (cfg.headline ? '<h3 class="pdp-ugc__heading">' + cfg.headline + '</h3>' : '') +
          '<div class="pdp-ugc__list">' + slidesHtml + '</div>' +
          '<div class="pdp-ugc__progress" aria-hidden="true"><div class="pdp-ugc__progress-thumb"></div></div>';

        wrap.querySelectorAll('.pdp-ugc__item').forEach((btn, i) => {
          btn.addEventListener('click', () => openVideoPopup(items[i].src));
        });

        // Wire the scrollbar-style progress thumb to track scroll position
        // and let the user drag it to scroll (mirrors the "You may also like"
        // slider pattern).
        const list = wrap.querySelector('.pdp-ugc__list');
        const progress = wrap.querySelector('.pdp-ugc__progress');
        const thumb = wrap.querySelector('.pdp-ugc__progress-thumb');
        const updateThumb = () => {
          const max = list.scrollWidth - list.clientWidth;
          if (max <= 0) {
            progress.style.display = 'none';
            return;
          }
          const ratio = list.clientWidth / list.scrollWidth;
          const left = (list.scrollLeft / max) * (1 - ratio) * 100;
          thumb.style.width = (ratio * 100) + '%';
          thumb.style.left = left + '%';
        };
        list.addEventListener('scroll', updateThumb, {passive: true});
        // Drag to scroll
        let dragging = false;
        let startX = 0;
        let startScrollLeft = 0;
        const onDown = (e) => {
          dragging = true;
          startX = (e.touches ? e.touches[0].clientX : e.clientX);
          startScrollLeft = list.scrollLeft;
          progress.classList.add('is-dragging');
        };
        const onMove = (e) => {
          if (!dragging) return;
          const x = (e.touches ? e.touches[0].clientX : e.clientX);
          const max = list.scrollWidth - list.clientWidth;
          const trackW = progress.clientWidth - thumb.clientWidth;
          if (trackW <= 0 || max <= 0) return;
          list.scrollLeft = startScrollLeft + ((x - startX) / trackW) * max;
        };
        const onUp = () => {
          if (!dragging) return;
          dragging = false;
          progress.classList.remove('is-dragging');
        };
        thumb.addEventListener('mousedown', onDown);
        thumb.addEventListener('touchstart', onDown, {passive: true});
        document.addEventListener('mousemove', onMove);
        document.addEventListener('touchmove', onMove, {passive: true});
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchend', onUp);

        anchor.after(wrap);
        // Initial thumb position after layout settles.
        requestAnimationFrame(updateThumb);
      };

      // Subtitle inserted immediately after the "You may also like" heading
      // inside <product-recommendations>. The recommendations block fetches
      // async, so if the heading isn't there yet we attach a one-shot
      // MutationObserver scoped to that root and try again when it mutates.
      const addRelatedSubtitle = () => {
        const cfg = relatedProducts[handle];
        if (!cfg || !cfg.subtitle) return true;
        const inject = (root) => {
          const heading = root.querySelector('h2, h3');
          if (!heading) return false;
          if (heading.parentElement.querySelector('.pdp-related__subtitle')) return true;
          const sub = document.createElement('p');
          sub.className = 'pdp-related__subtitle';
          sub.textContent = cfg.subtitle;
          heading.after(sub);
          return true;
        };
        const findRoot = () =>
          document.querySelector('.related-products') ||
          document.querySelector('product-recommendations');
        const root = findRoot();
        if (root && inject(root)) return true;
        // Heading not present yet — watch for it and inject when it lands.
        const target = root || document.body;
        const obs = new MutationObserver(() => {
          const r = findRoot();
          if (r && inject(r)) obs.disconnect();
        });
        obs.observe(target, {childList: true, subtree: true});
        return true;
      };

      // "Why BON CHARGE Wins" — comparison table inserted right after .how-it-works-wrapper.
      const addWhyWeWin = () => {
        const cfg = whyWeWin[handle];
        if (!cfg || document.querySelector('.pdp-wcw')) return;
        const checkSvg =
          '<svg viewBox="0 0 15.7009 15.7009" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M4.69626 7.85047L6.79906 9.95327L11.0047 5.74766M14.8598 7.85047C14.8598 11.7216 11.7216 14.8598 7.85047 14.8598C3.97931 14.8598 0.841121 11.7216 0.841121 7.85047C0.841121 3.97931 3.97931 0.841121 7.85047 0.841121C11.7216 0.841121 14.8598 3.97931 14.8598 7.85047Z" stroke="#55B705" stroke-width="1.68224" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
        const xSvg =
          '<svg viewBox="0 0 15.7009 15.7009" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M9.95327 5.74766L5.74766 9.95327M5.74766 5.74766L9.95327 9.95327M14.8598 7.85047C14.8598 11.7216 11.7216 14.8598 7.85047 14.8598C3.97931 14.8598 0.841121 11.7216 0.841121 7.85047C0.841121 3.97931 3.97931 0.841121 7.85047 0.841121C11.7216 0.841121 14.8598 3.97931 14.8598 7.85047Z" stroke="#D11726" stroke-width="1.68224" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';
        const rowsHtml = cfg.rows.map((r) => (
          '<div class="pdp-wcw__row">' +
          '<p class="pdp-wcw__label">' + r.label + '</p>' +
          '<div class="pdp-wcw__cells">' +
          '<div class="pdp-wcw__cell pdp-wcw__cell--us">' +
          '<span class="pdp-wcw__icon">' + checkSvg + '</span>' +
          '<p class="pdp-wcw__cell-text">' + r.us + '</p>' +
          '</div>' +
          '<div class="pdp-wcw__cell pdp-wcw__cell--them">' +
          '<span class="pdp-wcw__icon">' + xSvg + '</span>' +
          '<p class="pdp-wcw__cell-text">' + r.them + '</p>' +
          '</div>' +
          '</div>' +
          '</div>'
        )).join('');
        const wrap = document.createElement('div');
        wrap.classList.add('pdp-wcw');
        wrap.innerHTML =
          '<h3 class="pdp-wcw__heading">' + cfg.heading + '</h3>' +
          '<div class="pdp-wcw__cols">' +
          '<div class="pdp-wcw__col pdp-wcw__col--us">' + cfg.columnUs + '</div>' +
          '<div class="pdp-wcw__col pdp-wcw__col--them">' + cfg.columnThem + '</div>' +
          '</div>' +
          rowsHtml;
        const hiwWrap = document.querySelector('.how-it-works-wrapper');
        if (hiwWrap) hiwWrap.after(wrap);
      };

      /* ----------------------------------------------------------------------
         Wait for <product-info> + its lazy children, then run updates.
         For sections without configured content, mark "found" preemptively
         so the inner observer can disconnect.
         ---------------------------------------------------------------------- */
      const productInfoObserver = new MutationObserver((mutations, obs) => {
        const productInfo = document.querySelector('product-info');
        if (!productInfo) return;
        obs.disconnect();

        const found = {
          freeShipping: false,
          description: !descriptions[handle],
          carousel: false,
          badges: false,
          infoBadges: false,
          details: false,// !details[handle],
          bestPaired: false,
          easyToUse: false,
          sab: !sabContent[handle],
          sabBanner: !sabBanner[handle],
          reviews: false,
          beforeAfter: !beforeAfterConfig[handle],
          installments: false,
          awardsBanner: false,
          ugc: !ugc[handle],
          relatedSubtitle: !relatedProducts[handle],
          titleSubtitle: !titleSubtitles[handle],
          floorFaq: false
        };

        const checkAll = () => {
          if (!found.freeShipping) {
            const freeShipping = productInfo.querySelector('#free-shipping-text');
            if (freeShipping) {
              found.freeShipping = true;
              updateFreeShippingText(freeShipping);
            }
          }
          if (!found.titleSubtitle) {
            const titleEl = productInfo.querySelector('.pd-product-info__title');
            if (titleEl && insertTitleSubtitle(titleEl)) {
              found.titleSubtitle = true;
            }
          }
          if (!found.description) {
            const description = productInfo.querySelector('.bch-product-short-description');
            if (description) {
              found.description = true;
              updateDescriptionText(description);
            }
          }
          if (!found.carousel) {
            const carousel = productInfo.querySelector('product-media-carousel');
            if (carousel) {
              found.carousel = true;
              updateCarousel(carousel);
            }
          }
          if (!found.badges) {
            const badges = productInfo.querySelector('.pdp-trust-badges__container');
            if (badges) {
              found.badges = true;
              updateTrustBadges(badges);
            }
          }
          if (!found.infoBadges) {
            const anchor = productInfo.querySelector('.pdp-trust-badges__container') ||
              productInfo.querySelector('.pdp-trust-badges');
            if (injectInfoBadges(anchor)) {
              found.infoBadges = true;
            }
          }
          if (!found.ugc) {
            const infoBadgesEl = productInfo.querySelector('.pdp-info-badges');
            if (infoBadgesEl) {
              addUgc(infoBadgesEl);
              found.ugc = true;
            }
          }
          if (!found.details) {
            const detailsAccordion = document.querySelector(
              '[id^="pdp-accordion-items-template--"][id$="main-details"]'
            );

            if (detailsAccordion) {
              found.details = true;
              updateDetails(detailsAccordion);
            }
          }
          if (!found.floorFaq) {
            if (moveFloorFaqsToAccordion()) found.floorFaq = true;
          }
          if (!found.bestPaired) {
            const bestPaired = document.querySelector('.pdp-best-paired-with');
            if (bestPaired) {
              found.bestPaired = true;
              updateBestPaired(bestPaired);
            }
          }
          if (!found.easyToUse) {
            const section = findEasyToUseSection();
            if (section) {
              found.easyToUse = true;
              updateEasyToUse(section);
              addWhatYoullNotice();
              addHowItWorks();
              addWhyWeWin();
            }
          }
          if (!found.sab) {
            const sab = document.getElementById('sab-pdp');
            if (sab) {
              found.sab = true;
              updateSab(sab);
            }
          }
          if (!found.sabBanner) {
            const banner = document.querySelector('.section-banner-sab');
            if (banner) {
              found.sabBanner = true;
              updateSabBanner(banner);
            }
          }
          if (!found.reviews) {
            const reviews = document.querySelector('.pdp-reviews');
            if (reviews) {
              found.reviews = true;
              updateReviews(reviews);
            }
          }
          if (!found.beforeAfter) {
            const ba = document.getElementById('beforeAfter-Section');
            if (ba) {
              found.beforeAfter = true;
              updateBeforeAfter(ba);
            }
          }
          if (!found.installments) {
            const paymentHost = productInfo.querySelector('shopify-payment-terms');
            if (hideInstallmentsCta(paymentHost)) {
              found.installments = true;
            }
          }
          if (!found.awardsBanner) {
            const banner = findAwardsBanner();
            if (banner) {
              found.awardsBanner = true;
              updateAwardsBanner(banner);
            } else if (awardsBanner[handle]) {
              if (insertAwardsBanner(awardsBanner[handle])) {
                found.awardsBanner = true;
              }
            }
          }
          if (!found.relatedSubtitle) {
            if (addRelatedSubtitle()) found.relatedSubtitle = true;
          }
          if (
            found.freeShipping && found.description && found.carousel &&
            found.badges && found.infoBadges && found.details && found.bestPaired &&
            found.sab && found.sabBanner && found.reviews && found.beforeAfter &&
            found.easyToUse && found.installments && found.awardsBanner &&
            found.relatedSubtitle
          ) {
            innerObserver.disconnect();
          }
        };

        const innerObserver = new MutationObserver(() => checkAll());
        checkAll();

        if (!found.freeShipping || !found.description || !found.carousel || !found.badges) {
          innerObserver.observe(productInfo, {childList: true, subtree: true});
        }
      });
      productInfoObserver.observe(document.body, {childList: true, subtree: true});

      // Judge.me "Ask a question" CTA → "Contact us". The widget loads async,
      // so watch for the button and swap once it appears, then disconnect.
      const renameAskBtn = () => {
        const btns = document.querySelectorAll('.jdgm-ask-question-btn');
        if (!btns.length) return false;
        btns.forEach((b) => { b.textContent = 'Contact us'; });
        return true;
      };
      if (!renameAskBtn()) {
        const askObs = new MutationObserver(() => {
          if (renameAskBtn()) askObs.disconnect();
        });
        askObs.observe(document.body, {childList: true, subtree: true});
      }
    };

    /* --------------------------------------------------------------------------
       Desktop bootstrap (≥ 750px) — selective. Mobile keeps its full pipeline;
       desktop only runs sections we've actually styled with desktop CSS.
       Today: WYN. Future stages add Effortless Results, etc.
       -------------------------------------------------------------------------- */
    const updateProductDesktop = () => {
      // Lift the WYN config + finder + adder into desktop scope. We can't call
      // updateProduct's inner functions from here, so we re-implement the
      // tiny piece we need.
      const cfg = whatYoullNotice[handle];
      if (!cfg) return;

      const findSection = () => {
        if (template === 'product.pd-product') return document.getElementById('easy-to-use');
        const sections = document.querySelectorAll('.shopify-section');
        for (const el of sections) {
          if (el.querySelector('product-info')) continue;
          if (el.innerText.toLowerCase().includes('easy to use')) return el;
        }
        return null;
      };

      const insert = () => {
        if (document.querySelector('.pdp-wyn')) return true;
        const section = findSection();
        if (!section) return false;
        // Tag the theme section so subsequent calls + CSS can target it.
        section.classList.add('easy-to-use');
        const checkIcon =
          '<svg viewBox="0 0 14.7194 14.7194" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M4.34892 7.35971L6.35612 9.36691L10.3705 5.35252M14.0504 7.35971C14.0504 11.0549 11.0549 14.0504 7.35971 14.0504C3.66457 14.0504 0.669065 11.0549 0.669065 7.35971C0.669065 3.66457 3.66457 0.669065 7.35971 0.669065C11.0549 0.669065 14.0504 3.66457 14.0504 7.35971Z" stroke="currentColor" stroke-width="1.33813" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        const itemsHtml = cfg.items.map((it) => (
          '<div class="pdp-wyn__item">' +
          '<div class="pdp-wyn__head">' +
          '<span class="pdp-wyn__icon">' + checkIcon + '</span>' +
          '<h5 class="pdp-wyn__title">' + it.title + '</h5>' +
          '</div>' +
          '<p class="pdp-wyn__text">' + it.text + '</p>' +
          '</div>'
        )).join('');
        const wrap = document.createElement('div');
        wrap.classList.add('pdp-wyn');
        wrap.innerHTML =
          '<h3 class="pdp-wyn__heading">' + cfg.heading + '</h3>' +
          '<div class="pdp-wyn__list">' + itemsHtml + '</div>' +
          (cfg.disclaimer ? '<p class="pdp-wyn__disclaimer">' + cfg.disclaimer + '</p>' : '');
        if (cfg.popup) {
          const list = wrap.querySelector('.pdp-wyn__list');
          list.classList.add('pdp-wyn__list--clickable');
          list.setAttribute('role', 'button');
          list.setAttribute('tabindex', '0');
          // openInfoPopup is closed over updateProduct's scope; redefine here.
          const open = (text) => {
            if (document.querySelector('.pdp-popup')) return;
            const overlay = document.createElement('div');
            overlay.className = 'pdp-popup';
            overlay.innerHTML =
              '<div class="pdp-popup__card" role="dialog" aria-modal="true">' +
              '<button type="button" class="pdp-popup__close" aria-label="Close">×</button>' +
              '<p class="pdp-popup__text">' + text + '</p>' +
              '</div>';
            const close = () => {
              document.removeEventListener('keydown', onKey);
              overlay.remove();
            };
            const onKey = (e) => { if (e.key === 'Escape') close(); };
            overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
            overlay.querySelector('.pdp-popup__close').addEventListener('click', close);
            document.addEventListener('keydown', onKey);
            document.body.appendChild(overlay);
            overlay.querySelector('.pdp-popup__close').focus();
          };
          list.addEventListener('click', () => open(cfg.popup));
          list.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              open(cfg.popup);
            }
          });
        }
        section.before(wrap);
        return true;
      };

      if (insert()) return;
      const obs = new MutationObserver(() => { if (insert()) obs.disconnect(); });
      obs.observe(document.body, {childList: true, subtree: true});
    };

    /* --------------------------------------------------------------------------
       Bootstrap — mobile only for now. Desktop is suspended pending design
       sign-off; updateProductDesktop() is kept in the source so we can
       re-enable it later by uncommenting the else branch.
       -------------------------------------------------------------------------- */
    const mq = window.matchMedia('(max-width: 749.98px)');
    if (mq.matches) {
      updateProduct();
    }
    // else { updateProductDesktop(); }
  });
})();
